import { CREATE_ACR, GET_ACRS_HISTORY, DELETE_ACR_HISTORY } from "./types";
import { AcrType } from "@type/HRM/acr";

export const createACRRequest = (data: AcrType) => {
  return {
    type: CREATE_ACR.CREATE_ACR_REQUEST,
    payload: { data },
  } as const;
};

export const createACRSuccess = (data: AcrType) => {
  return {
    type: CREATE_ACR.CREATE_ACR_SUCCESS,
    payload: { data },
  } as const;
};

export const createACRFailed = () => {
  return {
    type: CREATE_ACR.CREATE_ACR_FAILED,
  } as const;
};

export const getACRHistoryRequest = (data: string | number | null) => {
  return {
    type: GET_ACRS_HISTORY.GET_ACR_HISTORY_REQUEST,
    payload: { data },
  } as const;
};

export const getACRHistorySuccess = (data: AcrType) => {
  return {
    type: GET_ACRS_HISTORY.GET_ACR_HISTORY_SUCCESS,
    payload: {
      data,
    },
  } as const;
};

export const getACRHistoryFailed = () => {
  return {
    type: GET_ACRS_HISTORY.GET_ACR_HISTORY_FAILED,
  } as const;
};

export const deleteACRHistoryRequest = (data: {
  acrID: number;
  employeeID: string | number | null;
}) => {
  return {
    type: DELETE_ACR_HISTORY.DELETE_ACR_HISTORY_REQUEST,
    payload: { data },
  } as const;
};

export const deleteACRHistorySuccess = (data: { id: string | number }) => {
  return {
    type: DELETE_ACR_HISTORY.DELETE_ACR_HISTORY_SUCCESS,
    payload: {
      data,
    },
  } as const;
};

export const deleteACRHistoryFailed = () => {
  return {
    type: DELETE_ACR_HISTORY.DELETE_ACR_HISTORY_FAILED,
  } as const;
};

export type ACRActions =
  | ReturnType<typeof createACRRequest>
  | ReturnType<typeof createACRSuccess>
  | ReturnType<typeof createACRFailed>
  | ReturnType<typeof getACRHistoryRequest>
  | ReturnType<typeof getACRHistorySuccess>
  | ReturnType<typeof getACRHistoryFailed>
  | ReturnType<typeof deleteACRHistoryRequest>
  | ReturnType<typeof deleteACRHistorySuccess>
  | ReturnType<typeof deleteACRHistoryFailed>;
